import React from "react";

import { Banner } from "../../components/Banner";
import { Section } from "../../components/Section";
import { Title } from "../../components/Title";
import { Button } from "../../components/Button";
import { Image } from "../../components/Image";

import BannerImgDesktop from "./images/banner-desktop.webp";
import BannerImgMobile from "./images/banner-mobile.webp";
import DL from "./images/dl.webp";
import DR from "./images/dr.webp";
import Woman from "./images/woman.webp";

import "./styles/index.scss";

export const Landing = () => {
  return (
    <div className="Landing Landing--spendimeno">
      <Banner
        images={{
          desktop: BannerImgDesktop,
          mobile: BannerImgMobile,
        }}
        resize="contain"
        alt="Insieme per sostenere Pangea"
      />

      <Section
        decorations={{
          left: DL,
          right: DR,
        }}
        positionLeft="top"
        positionRight="top"
      >
        <div className="container text-center">
          <Title>Una borsa per tante donne</Title>
          <p className="mt-4 pb-md-4">
            Quest’anno, per celebrare la{" "}
            <b>Giornata Internazionale della donna</b>, Pam RetailPro sostiene la{" "}
            <b>Fondazione Pangea ETS</b>
            , che aiuta le donne vittime di violenza domestica, accogliendole
            con le loro figlie e i loro figli in luoghi sicuri.
            <br />
            <br />
            Per tutto il mese di marzo, presso i punti vendita Pam RetailPro
            aderenti all’iniziativa, hai l'opportunità di fare la differenza:
            con ogni acquisto della borsa “<b>Insieme per sostenere Pangea</b>”
            al prezzo di 0.99€ saranno donati 0,30€ al progetto “
            <b>Piccoli ospiti</b>
            ”.
          </p>
        </div>
      </Section>
      <Section className="bg">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6 align-content-center text-center">
              <Image src={Woman} />
            </div>
            <div className="col-12 col-md-6 d-flex flex-column align-content-center text-center align-self-center p-4">
              <p>
                Vuoi sapere di più sulle{" "}
                <b>
                  attività <br />
                  di Pangea
                </b>{" "}
                a favore delle donne?{" "}
              </p>
              <Button
                label="Scopri di più"
                href="https://pangeaonlus.org/"
                target="_parent"
                style={{ margin: "auto" }}
                size="small"
              />
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div className="container text-center">
          <p>
            <b>
              Dona e aiuterai Pangea a garantire un futuro migliore alle donne
              vittime di violenza domestica, alle loro bambine e ai loro
              bambini.{" "}
            </b>
          </p>
        </div>
      </Section>
    </div>
  );
};
